import {Injectable} from "@angular/core";
import {HttpObservable} from "../../http/services/http.wrapper";
import {ConfProxy} from "../../http/services";
import {ShortcutsData, ShortcutsUpdateRequest} from "../interfaces/shortcuts.data";
import {map} from "rxjs/operators";

@Injectable({ providedIn: 'root' })
  export class ShortcutsConfigProxy {
	public dateParser = new RegExp(".*");

	constructor(private confHttp: ConfProxy) {
	}

	public getShortcuts(): HttpObservable<ShortcutsData> {
		return this.confHttp.get("Shortcuts", "GetShortcuts",undefined,undefined,undefined,true)
					.pipe(map(raw => this.confHttp.parseDates(raw, this.dateParser)));
	}

	public updateShortcuts(shortcuts: ShortcutsUpdateRequest): HttpObservable<any> {
		return this.confHttp.put("Shortcuts", "Update", shortcuts);
	}
}
